import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Row, Tooltip } from '../../primitives';
import { LibColor, Text } from '../../new-libby/core';
import { Icon } from '../icon/icon';
import { iconsMap } from '../../icons';
import { useDebounce } from '@wix/answers-lib';
import { createResizeObserver } from '../../common/resize-observer';
export var ResponsiveBreadcrumbs = function (props) {
    var items = props.items, rtl = props.rtl, className = props.className, size = props.size, noItemsShrinkage = props.noItemsShrinkage;
    var classNames = namespacedClassnames(compKey, className, { rtl: rtl });
    var rowClassNames = namespacedClassnames('breadcrumbs-row');
    var itemsRef = React.useRef([]);
    var breadCrumbWrapper = React.createRef();
    var _a = React.useState(items.length), hideFrom = _a[0], setHideFrom = _a[1];
    var breadCrumbIcon = iconsMap.arrowRight;
    var cutLimit = 45;
    var breadcrumbElementClass = 'breadcrumb-item';
    var rootEllipsesClass = namespacedClassnames('root-ellipses', { hide: hideFrom === items.length });
    var handleResize = function (items, itemsRefCurrent) {
        setHideFrom(items.length);
        var breadcrumbs = itemsRefCurrent;
        if (breadcrumbs) {
            breadcrumbs.forEach(function (item, idx) {
                var elementText = item.children[0];
                var textHasOverflow = elementText && elementText.clientWidth < elementText.scrollWidth;
                if (textHasOverflow && item.clientWidth < cutLimit) {
                    setHideFrom(idx);
                }
            });
        }
    };
    var debounceUpdate = useDebounce(function () { return handleResize(items, itemsRef.current); }, 100);
    var resizeObserver = createResizeObserver(debounceUpdate);
    React.useEffect(function () {
        setHideFrom(items.length);
    }, [items.length]);
    React.useEffect(function () {
        if (breadCrumbWrapper.current) {
            resizeObserver.observeElem(breadCrumbWrapper.current);
        }
        return function () {
            if (breadCrumbWrapper.current) {
                resizeObserver.unobserveElem(breadCrumbWrapper.current);
            }
            resizeObserver.clean();
        };
    }, []);
    var getFontType = function (isLastElement) {
        return size === 'medium' ?
            isLastElement ? 'tm' : 't' :
            isLastElement ? 'tsm' : 'ts';
    };
    var renderTooltipBreadCrumbItems = function () {
        var renderIcon = React.createElement(Icon, { color: LibColor.grey100, className: 'tooltip-breadcrumb-separator', icon: breadCrumbIcon });
        return (React.createElement(Row, { verticalAlignment: 'center', className: 'tooltip-body-content' }, items.map(function (item, idx) {
            var isLastElement = idx === items.length - 1;
            var fontType = getFontType(isLastElement);
            return (React.createElement(Row, { verticalAlignment: 'center', key: idx.toString() + 'tt' },
                React.createElement(Text, { type: fontType, className: 'label', color: 't50' }, item.label),
                idx < items.length - 1 ? renderIcon : null));
        })));
    };
    var renderBreadCrumbItems = function () {
        var renderIcon = React.createElement(Icon, { color: LibColor.dark30, className: 'breadcrumb-separator', icon: breadCrumbIcon });
        return items.map(function (item, idx) {
            var isLastElement = idx === items.length - 1;
            var refF = function (el) { return el ? itemsRef.current[idx] = el : null; };
            var maybeHidden = !isLastElement && (hideFrom <= idx) ? 'hide' : '';
            var maybeLastItemWithShrink = isLastElement && hideFrom === 0 ? 'with-shrink' : '';
            var breadCrumbClass = namespacedClassnames(breadcrumbElementClass, maybeHidden, { last: isLastElement }, { clickable: !!item.onClick }, maybeLastItemWithShrink);
            var onClick = function (event) {
                if (item.onClick) {
                    item.onClick(idx, event);
                }
            };
            var fontType = getFontType(isLastElement);
            var shrinkageCalc = Math.pow(2, (1 + idx));
            var flexShrink = !noItemsShrinkage && !isLastElement ?
                shrinkageCalc : (hideFrom === 0 || items.length === 1) ? 1 : 0;
            var shouldShowIcon = (idx < items.length - 1);
            var textColor = !!item.onClick ? 't60' : props.fontColor || 't20';
            return (React.createElement(React.Fragment, null,
                isLastElement ? rootEllipses : null,
                React.createElement("div", { onClick: onClick, ref: refF, key: idx, style: { flexShrink: flexShrink }, className: breadCrumbClass },
                    React.createElement(Text, { color: textColor, type: fontType, className: 'label' }, item.label),
                    shouldShowIcon ? renderIcon : null)));
        });
    };
    var rootEllipses = (React.createElement("div", { className: rootEllipsesClass },
        React.createElement(Text, { type: 'htm' }, "..."),
        React.createElement(Icon, { color: LibColor.dark30, className: 'root-ellipses-icon', icon: breadCrumbIcon })));
    var toolTipClass = namespacedClassnames('bread-crumb-tooltip', { rtl: rtl });
    return (React.createElement("div", { ref: breadCrumbWrapper, className: classNames },
        React.createElement(Tooltip, { relativeToBody: true, forceHidden: props.hideTooltip, className: toolTipClass, body: renderTooltipBreadCrumbItems() },
            React.createElement(Row, { verticalAlignment: 'center', className: rowClassNames }, renderBreadCrumbItems()))));
};
//# sourceMappingURL=index.js.map